import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { installNetworkMonitor } from "./lib/network/networkMonitor";

// Installed before the app renders so the diagnostics panel can capture the very first
// request of the session (it stays a pass-through until recording is switched on).
installNetworkMonitor();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
